/**
 * True only for a PLAIN primary-button click with no modifier keys — the single gesture an app
 * should intercept to drive SPA navigation. Every other gesture must fall through to the browser's
 * native behavior so a real `<a href>` opens a new tab/window/context-menu:
 *   - cmd/ctrl+click  → new tab
 *   - shift+click     → new window
 *   - alt+click       → download
 *   - middle-click    → new tab (fires `auxclick`, never `click`)
 *   - right-click     → context menu "Open link in new tab" (fires `contextmenu`, never `click`)
 *
 * Mirrors React Router's `shouldProcessLinkClick` / `isModifiedEvent`: intercept
 * `button === 0 && !meta && !ctrl && !shift && !alt` and do nothing for anything else.
 */
export function isPlainLeftClick(
  event: Pick<
    MouseEvent,
    'button' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey'
  >
): boolean {
  return (
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey
  );
}
